import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
    selector: 'app-simple-toggle',
    templateUrl: './simple-toggle.component.html',
    styleUrl: './simple-toggle.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleToggleComponent {
  @Input() isChecked: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() isCheckedChange: EventEmitter<boolean> = new EventEmitter<boolean>;
  //public labelName: string = "Display Name";

  public guid: string = "";
  public checkedColor = 'green';
  public borderColor = 'darkgreen';

  constructor(public utils: UtilService) {
    this.guid = utils.newGuid();
  }

  toggleCheckBox() {
    this.isChecked = !this.isChecked;
    this.isCheckedChange.emit(this.isChecked);
  }


}
